module.exports = __webpack_public_path__ + "static/media/04_Mascotte_chaud.e7c450c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/04_Mascotte_chaud.svg
// module id = 760
// module chunks = 0